import React, { useState, useEffect } from "react";
import "../css/SectionCard.css";
import FieldRenderer from "./FieldRenderer";
import sectionSchema from "../config/sectionSchema";

export default function SectionCard({ section, page, onSaved }) {

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState("");

  const schemaFields = sectionSchema?.[page]?.[section.sectionId] || [];

  useEffect(() => {
  const initialData = {};

  if (!section.fields) {
    setFormData(initialData);
    return;
  }

  //section.fields.forEach(f => {
    section.fields
  .filter(f => !(f.fieldType === "group" && f.parentKey === null))
  .forEach(f => {
    const { fieldKey, value, parentKey, groupIndex } = f;

    // TOP LEVEL — no parentKey
    if (!parentKey) {
      initialData[fieldKey] = value;
      return;
    }

    // NESTED — parentKey can be:
    // "banners"             → initialData.banners[groupIndex][fieldKey]
    // "products.0.metrics"  → initialData.products[0].metrics[groupIndex][fieldKey]
    const segments = parentKey.split(".");
    let cursor = initialData;

    let i = 0;
    while (i < segments.length) {
      const key = segments[i];
      const nextSeg = segments[i + 1];

      if (nextSeg !== undefined && !isNaN(Number(nextSeg))) {
        // e.g. "products" followed by "0" — step into products[0]
        const idx = Number(nextSeg);
        if (!cursor[key]) cursor[key] = [];
        if (!cursor[key][idx]) cursor[key][idx] = {};
        cursor = cursor[key][idx];
        i += 2;
      } else {
        // Last key segment — cursor[key] is the target array
        if (!cursor[key]) cursor[key] = [];
        //  Don't set cursor yet — initialize the slot first
        if (!cursor[key][groupIndex]) cursor[key][groupIndex] = {};
        cursor[key][groupIndex][fieldKey] = value;
        return; //  done, exit forEach callback
      }
    }

    // Fallback (shouldn't reach here with the return above)
    if (!cursor[groupIndex]) cursor[groupIndex] = {};
    cursor[groupIndex][fieldKey] = value;
  });

  setFormData(initialData);
  console.log("FORM DATA BUILT:", JSON.stringify(initialData, null, 2));
}, [section]);

  //  BUILD FORM DATA FROM DB
//   useEffect(() => {
//   const initialData = {};

//   if (!section.fields) {
//     setFormData(initialData);
//     return;
//   }

//   section.fields.forEach((f) => {
//     const { fieldKey, value, parentKey, groupIndex } = f;

//     // 🔹 TOP LEVEL
//     if (!parentKey) {
//       initialData[fieldKey] = value;
//       return;
//     }

//     // 🔹 HANDLE GROUPS (simple + nested)
//     const keys = parentKey.split(".");
//     let current = initialData;

//     keys.forEach((key, idx) => {
//       // last key → assign array
//       if (idx === keys.length - 1) {
//         if (!current[key]) current[key] = [];

//         if (!current[key][groupIndex]) {
//           current[key][groupIndex] = {};
//         }

//         current[key][groupIndex][fieldKey] = value;
//       } else {
//         // intermediate nesting
//         if (!current[key]) current[key] = [];
//         if (!current[key][groupIndex]) current[key][groupIndex] = {};

//         current = current[key][groupIndex];
//       }
//     });
//   });

//   setFormData(initialData);
// }, [section]);
//   useEffect(() => {

//   const initialData = {};

//   if (!section.fields) {
//     setFormData(initialData);
//     return;
//   }

//   section.fields.forEach(f => {

//     const { fieldKey, value, parentKey, groupIndex } = f;

//     // 🔹 TOP LEVEL
//     if (!parentKey) {
//       initialData[fieldKey] = value;
//       return;
//     }

  
//     const segments = parentKey.split(".");
//     let cursor = initialData;

//     let i = 0;
//     while (i < segments.length) {

//       const key = segments[i];
//       const nextSeg = segments[i+1];
//       // Ensure the array exists
//       if (!cursor[key]) cursor[key] = [];

//       // Next segment is a numeric index → step into that array slot
//       //if (i + 1 < segments.length && !isNaN(Number(segments[i + 1]))) {
//       if (nextSeg !== undefined && !isNaN(Number(nextSeg))) {
//         const idx = Number(nextSeg);
//         if (!cursor[key][idx]) cursor[key][idx] = {};
//         cursor = cursor[key][idx];
//         i += 2; // skip the number segment
//       } else {
//         // Last key segment — cursor[key] is the target array
//         cursor = cursor[key];
//         i += 1;
//       }

//     }

//     // cursor is now the array (e.g. products or metrics)
//     // groupIndex is the slot in that array
//     if (!cursor[groupIndex]) cursor[groupIndex] = {};
//     cursor[groupIndex][fieldKey] = value;

//   });

//   setFormData(initialData);

// }, [section]);
  // useEffect(() => {

  //   const initialData = {};

  //   if (section.fields) {

  //     section.fields.forEach(f => {

  //       const value = f.value;

  //       // 🔹 TOP LEVEL
  //       if (!f.parentKey) {
  //         initialData[f.fieldKey] = value;
  //         return;
  //       }

  //       // 🔹 GROUP LEVEL
  //       if (!initialData[f.parentKey]) {
  //         initialData[f.parentKey] = [];
  //       }

  //       if (!initialData[f.parentKey][f.groupIndex]) {
  //         initialData[f.parentKey][f.groupIndex] = {};
  //       }

  //       initialData[f.parentKey][f.groupIndex][f.fieldKey] = value;

  //     });

  //   }

  //   setFormData(initialData);

  // }, [section]);

  //  HANDLE CHANGE — supports both direct value and functional updater
  const handleChange = (key, valueOrFn) => {
    setFormData(prev => ({
      ...prev,
      [key]: typeof valueOrFn === "function"
        ? valueOrFn(prev[key] ?? [])
        : valueOrFn
    }));
  };

  //  RECURSIVE RENDER FUNCTION
  const renderFields = (fields, dataRef, setData) => {

    return fields.map(field => {

      // GROUP FIELD
      if (field.type === "group") {

        const items = dataRef[field.key] || [];

        return (
          <div key={field.key} className="groupContainer">

            <h4>{field.label || field.key}</h4>

            {items.map((_, index) => {

              // updateItem uses functional updater — no stale closure
              const updateItem = (childKey, childValue) => {
                setData(field.key, (prevItems) => {
                  const updated = [...(prevItems ?? [])];
                  updated[index] = {
                    ...updated[index],
                    [childKey]: typeof childValue === "function"
                      ? childValue(updated[index]?.[childKey] ?? [])
                      : childValue
                  };
                  return updated;
                });
              };

              return (
                <div key={index} className="groupItem">

                  {/*  items[index] — live ref, not stale item snapshot */}
                  {renderFields(
                    field.fields,
                    items[index] || {},
                    updateItem
                  )}

                  <button
                    className="removeBtn"
                    onClick={() => {
                      // functional updater
                      setData(field.key, (prev) => prev.filter((_, i) => i !== index));
                    }}
                  >
                    Remove
                  </button>

                </div>
              );
            })}

            <button
              className="addBtn"
              disabled={field.limit && items.length >= field.limit}
              onClick={() => {
                // functional updater
                setData(field.key, (prev) => [...(prev ?? []), {type: ""}]);
              }}
            >
             Add Item
            </button>

          </div>
        );
      }

      //  NORMAL FIELD
      return (
        <FieldRenderer
          key={field.key}
          field={{
            ...field,
            value: dataRef?.[field.key],
            tagValue: dataRef?.[field.key + "_tag"],
            parentValues: dataRef
          }}
          onChange={(k, v) => {
            setData(k, v);
          }}
        />
      );

    });

  };

  //  SAVE
  const saveChanges = async () => {
    setSaving(true);
    setSaveMsg("");
    try {

      const res = await fetch("/api/save-section", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          sectionId: section.id,
          data: formData,
          pageId: page,
          userId: 1
        })
      });

      const result = await res.json();
      if(result.success) {
        setSaveMsg(`Saved - ${result.changed ?? 0} field(s) changed`);
        setTimeout(()=> {
          setSaveMsg("");
          setOpen(false);
          onSaved?.();
        }, 1200);
      } else {
        setSaveMsg("Save failed. Please try again.");
      }
      //setOpen(false);

    } catch (error) {
      console.error("Update failed:", error);
       setSaveMsg("Network error. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sectionCard">

      <div className="sectionHeader">
        <h3>{section.label}</h3>

        <button
          className="editButton"
          onClick={() => setOpen(!open)}
        >
          {open ? "Close" : "Edit"}
        </button>
      </div>

      {open && (
        <div className="sectionBody">

          {renderFields(schemaFields, formData, handleChange)}

          {saveMsg && (
            <p className={`saveMsg ${saveMsg.includes("failed") || saveMsg.includes("error") ? "error" : "success"}`}>
              {saveMsg}
            </p>
          )}

          <div className="buttonRow">

            <button
              className="saveButton"
              onClick={saveChanges}
              disabled={saving}
            >
              {saving ? "Saving...": "Save"}
            </button>

            <button
              className="cancelButton"
              onClick={() => setOpen(false)}
              disabled={saving}
            >
              Cancel
            </button>

          </div>

        </div>
      )}

    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import "../css/SectionCard.css";
// import FieldRenderer from "./FieldRenderer";
// import sectionSchema from "../config/sectionSchema";

// export default function SectionCard({ section, page }) {

//   const [open, setOpen] = useState(false);
//   const [formData, setFormData] = useState({});

//   const schemaFields = sectionSchema?.[page]?.[section.sectionId] || [];

//   //  BUILD FORM DATA FROM DB
//   useEffect(() => {

//     const initialData = {};

//     if (section.fields) {

//       section.fields.forEach(f => {

//         const value = f.value;

//         // 🔹 TOP LEVEL
//         if (!f.parentKey) {
//           initialData[f.fieldKey] = value;
//           return;
//         }

//         // 🔹 GROUP LEVEL
//         if (!initialData[f.parentKey]) {
//           initialData[f.parentKey] = [];
//         }

//         if (!initialData[f.parentKey][f.groupIndex]) {
//           initialData[f.parentKey][f.groupIndex] = {};
//         }

//         initialData[f.parentKey][f.groupIndex][f.fieldKey] = value;

//       });

//     }

//     setFormData(initialData);

//   }, [section]);

//   // 🔹 HANDLE CHANGE (top level)
//   const handleChange = (key, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   //  RECURSIVE RENDER FUNCTION
//   const renderFields = (fields, dataRef, setData) => {

//     return fields.map(field => {

//       //  GROUP FIELD
//       if (field.type === "group") {

//         const items = dataRef[field.key] || [];

//         return (
//           <div key={field.key} className="groupContainer">

//             <h4>{field.label || field.key}</h4>

//             {items.map((item, index) => {

//               const updateItem = (updatedItem) => {
//                 const updated = [...items];
//                 updated[index] = updatedItem;
//                 setData(field.key, updated);
//               };

//               return (
//                 <div key={index} className="groupItem">

//                   {/*  RECURSION (supports nested groups like metrics) */}
//                   {renderFields(
//                     field.fields,
//                     item,
//                     (childKey, childValue) => {
//                       updateItem({
//                         ...item,
//                         [childKey]: childValue
//                       });
//                     }
//                   )}

//                   <button
//                     className="removeBtn"
//                     onClick={() => {
//                       const updated = items.filter((_, i) => i !== index);
//                       setData(field.key, updated);
//                     }}
//                   >
//                     Remove
//                   </button>

//                 </div>
//               );
//             })}

//             <button
//               className="addBtn"
//               disabled={field.limit && items.length >= field.limit}
//               onClick={() => {
//                 setData(field.key, [...items, {}]);
//               }}
//             >
//               Add Item
//             </button>

//           </div>
//         );
//       }

//       // NORMAL FIELD
//       return (
//         <FieldRenderer
//           key={field.key}
//           field={{
//             ...field,
//             value: dataRef[field.key],
//             tagValue: dataRef[field.key + "_tag"]
//           }}
//           onChange={(k, v) => {
//             setData(k, v);
//           }}
//         />
//       );

//     });

//   };

//   // 🔹 SAVE
//   const saveChanges = async () => {
//     try {

//       await fetch("http://localhost:5000/api/save-section", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           sectionId: section.id,
//           data: formData,
//           pageId: page,
//           userId: 1
//         })
//       });

//       setOpen(false);

//     } catch (error) {
//       console.error("Update failed:", error);
//     }
//   };

//   return (
//     <div className="sectionCard">

//       <div className="sectionHeader">
//         <h3>{section.label}</h3>

//         <button
//           className="editButton"
//           onClick={() => setOpen(!open)}
//         >
//           {open ? "Close" : "Edit"}
//         </button>
//       </div>

//       {open && (
//         <div className="sectionBody">

//           {renderFields(schemaFields, formData, handleChange)}

//           <div className="buttonRow">

//             <button
//               className="saveButton"
//               onClick={saveChanges}
//             >
//               Save
//             </button>

//             <button
//               className="cancelButton"
//               onClick={() => setOpen(false)}
//             >
//               Cancel
//             </button>

//           </div>

//         </div>
//       )}

//     </div>
//   );
// }